import { render, staticRenderFns } from "./LinkPacienteProfesional.vue?vue&type=template&id=49ad946c&scoped=true"
import script from "./LinkPacienteProfesional.vue?vue&type=script&lang=js"
export * from "./LinkPacienteProfesional.vue?vue&type=script&lang=js"
import style0 from "./LinkPacienteProfesional.vue?vue&type=style&index=0&id=49ad946c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ad946c",
  null
  
)

export default component.exports